const home =
{
    title       : 'Bienvenue sur le gestionnaire de contenu de Micro-Aventure.' ,
    description : 'Gérez votre application culturelle et touristique vous-même.'
};

export default home  ;
